











import { defineComponent } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import LockButton from './LockButton.vue';
import UpgradeInfo from './UpgradeInfo.vue';

export default defineComponent({
  components: {
    LockButton,
    UpgradeInfo,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    offset: {
      type: Array as PropType<number[]>,
      default: () => [0, 0],
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
  },
  emits: ['contact'],
});
